import { faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons"
import LaunchButton from "@/components/LaunchButton"
import Modal from "@/components/modal"
import { Document } from "../../model/document.types"
import { toast } from "react-toastify"
import { useState } from "react"
import { useAppSelector } from "@/core/root-reducer"
import ComingSoonModal from "@/modals/coming-soon.modal"

interface Props {
  document: Document
  onClose: () => void
  onExportPdf: () => void
}

export default function DocumentExportModal({ document, onClose, onExportPdf }: Props) {
  const [isExporting, setIsExporting] = useState(false)
  const [isComingSoon, setIsComingSoon] = useState(false)
  const primaryColor = useAppSelector((state) => state._session.accountColors.brandPrimary)

  async function exportExcel() {
    if (isExporting) return
    if (document.url) {
      toast("L’export Excel est disponible pour les DUERP générés dans l’application.", { type: "info" })
      return
    }
    if (document.type !== "duerp") {
      setIsComingSoon(true)
      return
    }
    setIsExporting(true)
    try {
      const { exportDocumentToExcel } = await import("../../utils/exportDocumentToExcel")
      exportDocumentToExcel(document, primaryColor)
      onClose()
    } catch {
      toast("Le fichier Excel n’a pas pu être généré. Vous pouvez réessayer.", { type: "error" })
    } finally {
      setIsExporting(false)
    }
  }
  return (
    <Modal title="Télécharger le document" isCloseButtonVisible onClose={onClose}>
      {isComingSoon && <ComingSoonModal onClose={() => setIsComingSoon(false)} />}
      <div className="flex gap-[12px]">
        <LaunchButton title="Export PDF" icon={faFilePdf} onClick={onExportPdf} />
        <LaunchButton title={isExporting ? "Export en cours…" : "Export Excel"} icon={faFileExcel} onClick={exportExcel} />
      </div>
    </Modal>
  )
}
